module.exports = __webpack_public_path__ + "img/co2.7327e420.jpg";